import React from "react"
// import moment from 'moment'
// import ReactInterval from "react-interval"
import Header from "../components/header"
import Footer from "../components/footer"

import { Redirect } from "react-router-dom"

import { MessageBox } from "../common/messagebox"

import { commonErr } from "../common/errors"

import { VNCitiesMap, isPhoneValid, isEmailValid, trackBizRegisterToAccessTrade} from "../common/common"
import { submitFormBizRegister } from "../../model/common"

// import bg_etp from "../../static/images/background/bg-enterprise.jpg"
// import bg_agency from "../../static/images/background/bg-enterprise-1.jpg"
// import bg_secondary from "../../static/images/background/bg-cta-register.jpg"


const B2BMode = {
	ENTERPRISE: "enterprise", 
	AGENCY: "agency",
}


export default class B2BRegister extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			isSubmittedSuccess: false,
			name: "",
			phoneNumber: "",
			city: "",
			email: "",
			website: "",
		
			etpName: "",
			etpSize: "",
			// etpDivision: "",
			// etpRoll: "",
			etpBusinessModel: "",
			etpTripAmount: "",

			ptBusinessModel: "",
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.refreshCheckFilled();
		this.initRegisType();
	}

	initRegisType = () => {
		const { mode } = this.props.match.params;
		if (mode === B2BMode.ENTERPRISE) {
			
			this.setState({
				registerType: 1
			})
		} else {
		
			this.setState({
				registerType: 2
			})
		}
	}

	handleInputChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value
		});
	}
    
	refreshCheckFilled = () => {
		this.setState({
			isNameFilled: true,
			isPhoneFilled: true,
			isCityFilled: true,
			isEmailFilled: true,
			isEtpNameFilled: true,
			isEtpSizeFilled: true,
			isPtBusinessModelFilled: true,
			isEtpTripAmountFilled: true
		})
	}

	hideMessageBox = () => {
		this.setState({
			err: commonErr.INNIT,
			errMsg: ""
		});
	}

	isValidInfo = () => {
		const { mode } = this.props.match.params;

		this.refreshCheckFilled();
		if (this.state.city === "" || !this.state.city) {
			this.setState({
				isCityFilled: false,
			})
			return "Bạn chưa chọn thành phố."
		}


		if (this.state.name === "" || !this.state.name) {
			this.setState({
				isNameFilled: false,
			})
			return "Bạn chưa điền tên."
		}
		if (this.state.phoneNumber === "" || !this.state.phoneNumber) {
			this.setState({
				isPhoneFilled: false,
			})
			return "Bạn chưa điền số điện thoại."
		}
		if (!isPhoneValid(this.state.phoneNumber)) {
			this.setState({
				isPhoneFilled: false,
			})
			return "Số điện thoại không hợp lệ."
		}
		
		if (this.state.email !== "") {
			if (!isEmailValid(this.state.email)) {
				this.setState({
					isEmailFilled: false,
				})
				return "Email không hợp lệ."
			}
		}

		if (mode === B2BMode.ENTERPRISE) {
			if (this.state.etpName === "" || !this.state.etpName) {
				this.setState({
					isEtpNameFilled: false,
				})
				return "Bạn chưa điền tên công ty"
			}
			if (this.state.etpSize === "" || !this.state.etpSize) {
				this.setState({
					isEtpSizeFilled: false,
				})
				return "Bạn chưa chọn quy mô công ty."
			}
			if (this.state.etpTripAmount === "" || !this.state.etpTripAmount) {
				this.setState({
					isEtpTripAmountFilled: false,
				})
				return "Bạn chưa chọn số lượng chuyến đi"
			}
		}

		if (mode === B2BMode.AGENCY) {
			
			if (this.state.ptBusinessModel === "" || !this.state.ptBusinessModel) {
				this.setState({
					isPtBusinessModelFilled: false,
				})
				return "Bạn chưa chọn lĩnh vực kinh doanh."
			}
		}
	
		return "";
	}

	onSubmitFormRegister = (event) => {
		

		const message = this.isValidInfo();
		if (message !== "") {
			this.setState({
				err: commonErr.FAIL,
				errMsg: message
			})
		} else {
			const data = {
				name: this.state.name,
				phoneNumber: this.state.phoneNumber,
				city: this.state.city,
				email: this.state.email,
				registerType: this.state.registerType,
				website: this.state.website,
		
				etpName: this.state.etpName,
				etpSize: this.state.etpSize,
				// etpDivision: this.state.etpDivision,
				// etpRoll: this.state.etpRoll,
				etpTripAmount: this.state.etpTripAmount,
				etpBusinessModel: this.state.etpBusinessModel,

				ptBusinessModel: this.state.ptBusinessModel,
			}
        
			
			this.setState({ err: commonErr.LOADING });

			submitFormBizRegister(data).then(resp => {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
				if (resp.data.error >= commonErr.SUCCESS) {

					const regId = resp.data.data.etp.regId;
					trackBizRegisterToAccessTrade(regId)

					this.setState({
						isSubmittedSuccess: true,
						errMsg: this.renderMessage(),
					});
					
				}
				else {
					this.setState({
						isSubmittedSuccess: false
					});
				}
			});
		}
	}

	renderMessage = () => {
		return (
			<div className='message-box'>
				Gửi yêu cầu thành công
        <p>Yêu cầu đăng ký trở thành đại lý của bạn đã được gửi.</p>
				<p>Bộ phận phát triển kinh doanh của Mioto sẽ liên hệ bạn để tư vấn và hợp tác trong thời gian sớm nhất.</p>
				<p>Để được hỗ trợ, vui lòng gọi hotline 19009217 (T2-T7, 9AM-9PM).</p>
				<p>Xin cám ơn,</p>
				<p>MIOTO TEAM</p>
			</div>
		)
	}

	
	render() {
			const { mode } = this.props.match.params
			const { isNameFilled, isPhoneFilled, isCityFilled, isEmailFilled, isEtpNameFilled, isEtpSizeFilled, isEtpTripAmountFilled, isPtBusinessModelFilled } = this.state;
			
			if (mode !== B2BMode.ENTERPRISE && mode !== B2BMode.AGENCY) return <Redirect to="/notfound" />
		
			return <div className="mioto-layout">
				<Header />
				<section className="body">

					{mode === B2BMode.ENTERPRISE && <div><div className="banner-home__sect owner-register__wrap" id="ownerRegister" style={{ backgroundImage: `url(${bg_etp})` }}>
						<div className="reg-container">
							<div className="main-title">
								<h2 className="reg-tt">GIẢI PHÁP THUÊ XE THÔNG MINH CHO MỌI DOANH NGHIỆP</h2>
								<p>Hotline: 1900 9217 (T2-T7 9AM-9PM)</p>
								<p>Hoặc để lại thông tin cho Mioto qua email <a href="mailto:contact@mioto.vn">contact@mioto.vn</a></p>
							</div>
							<div className="box-register">
								<div className="form-register form-default">
									<h4 className="title">TƯ VẤN DỊCH VỤ THUÊ XE - KHÁCH HÀNG DOANH NGHIỆP</h4>
									<p>Vui lòng điền thông tin đầy đủ và chính xác để Mioto liên hệ bạn sớm nhất </p>
									<div className="form-group">
									<div className="line-form">
										<div className={isCityFilled ? "wrap-select" : "wrap-select has-error-form"}>
											<select required onChange={this.handleInputChange} name="city" value={this.state.city}>
												<option value="" hidden disabled>Thành phố đăng ký kinh doanh </option>
												{VNCitiesMap && VNCitiesMap.map(option => <option key={option.key} value={option.key}>{option.value}</option>)}
											</select>
										</div>
									</div>
									<div className="line-form w-60">
										<div className={isNameFilled ? "wrap-input" : "wrap-input has-error-form"}>
											<input type="text" placeholder="Họ và tên*" name="name" value={this.state.name} onChange={this.handleInputChange} />
										</div>
									</div>
									<div className="line-form w-40">
										<div className={isPhoneFilled ? "wrap-input" : "wrap-input has-error-form"}>
											<input type="text" placeholder="Số di động*" name="phoneNumber" value={this.state.phoneNumber} onChange={this.handleInputChange} />
										</div>
									</div>
									<div className="line-form">
										<div className={isEmailFilled ? "wrap-input" : "wrap-input has-error-form"}>
											<input type="text" placeholder="Địa chỉ email*" name="email" value={this.state.email} onChange={this.handleInputChange} />
										</div>
									</div>
									<p>Vui lòng cung cấp một số thông tin về doanh nghiệp của bạn để Mioto đề xuất giải pháp phù hợp nhất</p>
									<div className="line-form">
										<div className={isEtpNameFilled ? "wrap-input" : "wrap-input has-error-form"}>
											<input type="text" placeholder="Tên công ty*" name="etpName" value={this.state.etpName} onChange={this.handleInputChange} />
										</div>
									</div>
									<div className="line-form">
										<div className="wrap-input">
											<input type="text" placeholder="Website công ty" name="website" value={this.state.website} onChange={this.handleInputChange} />
										</div>
									</div>
									<div className="line-form">
										<div className={isEtpSizeFilled ? "wrap-select" : "wrap-select has-error-form"}>
												<select required name="etpSize" onChange={this.handleInputChange} value={this.state.etpSize}>
													<option value="" hidden disabled>Quy mô công ty </option>
													<option value="100"> &lt; 100 nhân viên</option>
													<option value="249">100 - 249 nhân viên</option>
													<option value="500">250 - 500 nhân viên</option>
													<option value="501">&gt;500 nhân viên</option>
												</select>
											</div>
									</div>
										<div className="line-form">
											{/* <div className="wrap-input">
												<input type="text" placeholder="Chức vụ" name="etpDivision" value={this.state.etpDivision} onChange={this.handleInputChange} />	
											</div> */}
											<div className={isEtpTripAmountFilled ? "wrap-select" : "wrap-select has-error-form"}>
												<select required name="etpTripAmount" onChange={this.handleInputChange} value={this.state.etpTripAmount}>
													<option value="" hidden disabled>Số lượng chuyến / tháng</option>
													<option value="5"> 5 - 10 chuyến</option>
													<option value="10">10 - 30 chuyến</option>
													<option value="30">30 - 50 chuyến</option>
													<option value="50">&gt;50 chuyến</option>
												</select>
											</div>
									</div>
										<div className="line-form">
											<div className="wrap-input">
												{/* <input type="text" placeholder="Phòng ban phụ trách" name="etpRoll" value={this.state.etpRoll} onChange={this.handleInputChange} /> */}
												<input type="text" placeholder="Ngành nghề kinh doanh" name="etpBusinessModel" value={this.state.etpBusinessModel} onChange={this.handleInputChange} />
											</div>
									</div>
								</div>
								<p className="read-paper">
									Khi tiếp tục, tôi đồng ý Mioto được phép thu thập, sử dụng và tiết lộ thông tin được tôi cung cấp theo <a href="https://www.mioto.vn/regu" target="_blank">Quy chế hoạt động</a> của Mioto mà tôi đã đọc và hiểu</p><a className="btn btn--m btn-primary" onClick={this.onSubmitFormRegister}>Đăng ký </a>
								</div>
							</div>
						</div>
					</div>
					<div className="reg-tutorial__sect">
						<div className="ex-container">
							<h3 className="n-title">Tại sao nên hợp tác với chúng tôi?</h3>
							<div className="reg-step__wrap">
								<div className="reg-step__item entp-benef"><i className="ict-mbenefit ict-saving" />
									<div className="step-detail">
										<h4>Tiết kiệm</h4>
										<p className="dt">Tiết kiệm 20% - 40% chi phí / tháng</p>
									</div>
								</div>
								<div className="reg-step__item entp-benef"><i className="ict-mbenefit ict-effective" />
									<div className="step-detail">
										<h4>Hiệu quả</h4>
										<p className="dt">Đặt xe nhanh chóng. Đội ngũ nhân viên chăm sóc tận tình</p>
									</div>
								</div>
								<div className="reg-step__item entp-benef"><i className="ict-mbenefit ict-quality" />
									<div className="step-detail">
										<h4>Chất lượng</h4>
										<p className="dt">Đội xe chất lượng. Tài xế chuyên nghiệp</p>
									</div>
								</div>
								<div className="reg-step__item entp-benef"><i className="ict-mbenefit ict-smart" />
									<div className="step-detail">
										<h4>Thông minh</h4>
										<p className="dt">Quản lý đơn hàng. Quản lý lịch trình. Rõ ràng và minh bạch</p>
									</div>
								</div>
							</div>
						</div>
					</div></div>}
			
					
					{mode === B2BMode.AGENCY && <div><div className="banner-home__sect owner-register__wrap" id="ownerRegister" style={{ backgroundImage: `url(${bg_agency})` }}>
						<div className="reg-container">
							<div className="main-title">
								<h2 className="reg-tt">HỢP TÁC CÙNG MIOTO NGAY HÔM NAY ĐỂ GIA TĂNG DOANH THU !</h2>
								<p>Bạn là chủ khách sạn, phòng vé, dịch vụ lữ hành, ứng dụng du lịch trực tuyến, dịch vụ tiệc cưới, công ty tổ chức sự kiện ?</p>
								<p>Bạn là chủ doanh nghiệp hoặc cá nhân kinh doanh tự do ?</p>
								<p>Chỉ cần bạn có khách hàng có nhu cầu thuê xe (tự lái hoặc có tài xế, đi nội thành hoặc liên tỉnh), Mioto chào đón bạn <span className="fontWeight-5">HỢP TÁC</span> cùng chúng tôi để mang lại giá trị gia tăng cho khách hàng và gia tăng doanh thu cho bạn.</p>
								<div className="space m"></div>
								<p>Hotline: 1900 9217 (T2-T7 9AM-9PM)</p>
								<p>Hoặc để lại thông tin cho Mioto qua email <a href="mailto:contact@mioto.vn">contact@mioto.vn</a></p>
							</div>
							<div className="box-register">
								<div className="form-register form-default">
									<h4 className="title">ĐĂNG KÝ ĐẠI LÝ KINH DOANH</h4>
									<p>Vui lòng điền thông tin đầy đủ và chính xác để Mioto liên hệ bạn sớm nhất </p>
									<div className="form-group">
									<div className="line-form">
										<div className={isCityFilled ? "wrap-select" : "wrap-select has-error-form"}>
											<select required onChange={this.handleInputChange} name="city" value={this.state.city}>
												<option value="" hidden disabled>Thành phố đăng ký kinh doanh </option>
												{VNCitiesMap && VNCitiesMap.map(option => <option key={option.key} value={option.key}>{option.value}</option>)}
											</select>
										</div>
									</div>
									<div className="line-form w-60">
										<div className={isNameFilled ? "wrap-input" : "wrap-input has-error-form"}>
											<input type="text" placeholder="Họ và tên*" name="name" value={this.state.name} onChange={this.handleInputChange} />
										</div>
									</div>
									<div className="line-form w-40">
										<div className={isPhoneFilled ? "wrap-input" : "wrap-input has-error-form"}>
											<input type="text" placeholder="Số di động*" name="phoneNumber" value={this.state.phoneNumber} onChange={this.handleInputChange} />
										</div>
									</div>
									<div className="line-form">
										<div className={isEmailFilled ? "wrap-input" : "wrap-input has-error-form"}>
											<input type="text" placeholder="Địa chỉ email*" name="email" value={this.state.email} onChange={this.handleInputChange} />
										</div>
									</div>
										<p>Vui lòng cung cấp một số thông tin về đơn vị kinh doanh của bạn để Mioto đề xuất giải pháp phù hợp nhất</p>	
										<div className="line-form">
										<div className={isPtBusinessModelFilled ? "wrap-select" : "wrap-select has-error-form"}>
											<select required name="ptBusinessModel" onChange={this.handleInputChange} value={this.state.ptBusinessModel}>
												<option value="" hidden disabled>Loại hình kinh doanh</option>
												<option value="hotel">Khách sạn</option>
												<option value="flight">Đại lý vé máy bay</option>
												<option value="travel">Đại lý du lịch</option>
												<option value="other">Khác</option>
											</select>
										</div>
									</div>
									<div className="line-form">
										<div className="wrap-input">
											<input type="text" placeholder="Địa chỉ Website/Fanpage (nếu có)" name="website" value={this.state.website} onChange={this.handleInputChange} />
										</div>
									</div>
								</div>
								<p className="read-paper">
									Khi tiếp tục, tôi đồng ý Mioto được phép thu thập, sử dụng và tiết lộ thông tin được tôi cung cấp theo <a href="https://www.mioto.vn/regu" target="_blank">Quy chế hoạt động</a> của Mioto mà tôi đã đọc và hiểu</p><a className="btn btn--m btn-primary" onClick={this.onSubmitFormRegister}>Đăng ký </a>
								</div>
							</div>
						</div>
					</div>
					<div class="reg-tutorial__sect">
            <div class="ex-container">
              <h3 class="n-title">Tại sao nên hợp tác với chúng tôi?</h3>
              <div class="reg-step__wrap">
								<div class="reg-step__item entp-benef"><i class="ict-mbenefit ict-variety"></i>
									<div class="step-detail">
										<h4>Đa dạng dịch vụ xe</h4>
										<p class="dt">Trọn gói các dịch vụ thuê xe (4-7 chỗ) tự lái và có tài xế theo yêu cầu</p>
									</div>
								</div>
								<div class="reg-step__item entp-benef"><i class="ict-mbenefit ict-management"></i>
									<div class="step-detail">
										<h4>Quản lý dễ dàng</h4>
										<p class="dt">Trang bị hệ thống hỗ trợ đặt xe online nhanh chóng. Đối soát và thống kê được doanh thu chi tiết</p>
									</div>
								</div>
								<div class="reg-step__item entp-benef"><i class="ict-mbenefit ict-best-price"></i>
									<div class="step-detail">
										<h4>Giá tốt nhất</h4>
										<p class="dt">Giá thuê tốt nhất từ hệ thống &gt; 2000 xe ô tô tại TPHCM, Hà Nội, Đà Nẵng và các tỉnh thành lớn</p>
									</div>
								</div>
								<div class="reg-step__item entp-benef"><i class="ict-mbenefit ict-commission"></i>
									<div class="step-detail">
										<h4>Hoa hồng hấp dẫn</h4>
										<p class="dt">Không phí đăng kí, không áp đặt doanh số. Tăng thêm 20-30% doanh thu trên mỗi khách hàng hiện có</p>
									</div>
								</div>
              </div>
            </div>
						</div>
					</div>}
	
					<div className="reg-cact__sect" style={{ backgroundImage: `url(${bg_secondary})` }}>
						<div className="inside ex-container">
							<h3 className="n-title">Tham gia Mioto ngay hôm nay! </h3>
							<p>Mioto - Cùng bạn trên mọi hành trình</p>
							<a href="#ownerRegister" className="btn btn--l btn-primary">Đăng ký ngay</a>
						</div>
					</div>
					<MessageBox show={this.state.err <= commonErr.SUCCESS} hideModal={this.hideMessageBox} message={this.state.errMsg} error={this.state.err} />
				</section>
				<Footer />
			</div>
		}
	}
